function arrayBufferToHex(buffer) {
  return Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

function arrayBufferToBase64(buffer) {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

function arrayBufferToBase64Url(buffer) {
  return arrayBufferToBase64(buffer)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

function formatOutput(buffer, format) {
  const fmt = (format || "hex-lower").toString().toLowerCase().trim();
  switch (fmt) {
    case "hex-lower":
    case "hex-lowercase":
      return arrayBufferToHex(buffer);
    case "hex-upper":
    case "hex-uppercase":
      return arrayBufferToHex(buffer).toUpperCase();
    case "base64":
      return arrayBufferToBase64(buffer);
    case "base64url":
    case "base64 url":
      return arrayBufferToBase64Url(buffer);
    default:
      return arrayBufferToHex(buffer);
  }
}

function flattenObject(obj, prefix, result) {
  if (obj === null) {
    result[prefix] = null;
    return;
  }
  if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      const key = prefix ? prefix + "." + i : "" + i;
      flattenObject(obj[i], key, result);
    }
    return;
  }
  if (typeof obj === "object") {
    for (const k of Object.keys(obj)) {
      if (k.toLowerCase() === "signature") continue;
      const key = prefix ? prefix + "." + k : k;
      flattenObject(obj[k], key, result);
    }
    return;
  }
  result[prefix] = obj;
}

function valueToString(val) {
  if (val === null) return "";
  if (val === undefined) return undefined;
  if (typeof val === "boolean") return val ? "true" : "false";
  if (typeof val === "string") {
    return val;
  }
  if (typeof val === "number") {
    if (Number.isInteger(val)) return val.toString();
    return parseFloat(val.toString()).toString();
  }
  return String(val);
}

const SignatureService = {
  arrayBufferToHex,
  arrayBufferToBase64,
  arrayBufferToBase64Url,
  formatOutput,
  flattenObject,
  valueToString,

  async sign(body, secretKey, config = {}) {
    if (!secretKey) throw new Error("Missing secretKey");

    let obj;
    try {
      obj = typeof body === "string" ? JSON.parse(body) : JSON.parse(JSON.stringify(body));
    } catch (e) {
      throw new Error("Invalid JSON format: " + e.message);
    }

    if (obj && typeof obj === "object" && "signature" in obj) {
      delete obj.signature;
    }

    const flatMap = {};
    flattenObject(obj, "", flatMap);

    const sortedKeys = Object.keys(flatMap).sort();

    const separator = config.separator != null ? config.separator : "";
    const values = sortedKeys.map((k) => valueToString(flatMap[k]));
    const message = values.join(separator);

    const algorithm = (config.algorithm || "SHA-512").trim();
    const outputFormat = config.outputFormat || "hex-lower";

    const encoder = new TextEncoder();
    const keyData = encoder.encode(secretKey);
    const messageData = encoder.encode(message);

    const cryptoKey = await window.crypto.subtle.importKey(
      "raw",
      keyData,
      { name: "HMAC", hash: algorithm },
      false,
      ["sign"]
    );

    const signatureBuffer = await window.crypto.subtle.sign(
      "HMAC",
      cryptoKey,
      messageData
    );

    const result = formatOutput(signatureBuffer, outputFormat);

    console.log("[SignatureService] message: %s", message);
    console.log("[SignatureService] result: %s", result);

    return result;
  },

  flatten(value, path, fields) {
    const flatMap = {};
    flattenObject(value, path || "", flatMap);
    for (const k of Object.keys(flatMap)) {
      fields.push([k, valueToString(flatMap[k])]);
    }
  },
};

export default SignatureService;
